import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function MachineryContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  machineId,
  showData,
  dataInfo,
  dataList,
  isListingLoading,
  permissions,
}) {
  useEffect(() => {
    if (_.isEmpty(machineId)) return;
    showData(machineId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(machineId)) return;
    showData(machineId);
  }, [machineId]);

  return (
    <div className="d-flex flex-column h-100">
      {Acl(permissions, ['CREATE E2E RPT MACHINERY MACHINES']) && (
        <div className="row mb-3">
          <div className="ml-auto">
            <button
              type="button"
              onClick={handleAddModal}
              className="d-flex align-items-center justify-content-center btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
              style={{ marginRight: 30 }}
            >
              <i className="fas fa-plus" />
              <span className="ml-2">Add Machinery</span>
            </button>
          </div>
        </div>
      )}
      <div className="ml-3 p-3 card right-section h-100">
        {!_.isEmpty(dataInfo) && !_.isEmpty(dataList) && !isListingLoading ? (
          <>
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-10">
                <h3 className="mb-0">Information</h3>
              </div>
              <div className="col-2 d-flex align-items-end justify-content-end">
                {Acl(permissions, ['UPDATE E2E RPT MACHINERY MACHINES']) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(dataInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                )}
                {Acl(permissions, ['DELETE E2E RPT MACHINERY MACHINES']) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(dataInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                )}
              </div>
            </div>
            <div className="mt-3 pt-4 border-top">
              <table className="transaction-table table table-borderless table-striped table-sm ">
                <tbody>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Name
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.name') || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Description
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.description') || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Brand / Model
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.brand_model') || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Capacity / HP
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.capacity') || '--'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MachineryContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  machineId: PropTypes.string.isRequired,
  isListingLoading: PropTypes.bool.isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  machineId: _.get(match, 'params.machineId') || '',
  isListingLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
  dataList: _.get(api, `${c.GET_LIST}.list`) || [],
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryContent);
